import classNames from 'classnames';
import type React from 'react';
import { useMemo } from 'react';

import type { IProps as IFallback } from './controls/fallback';
import DialogFooterFallback from './controls/fallback';

export interface IProps extends IFallback {
  className?: string;
}

const DialogFooter: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className: pClassName,
  ...props
}) => {
  const className = useMemo(() => {
    return classNames('flex pt-4 shrink-0', pClassName);
  }, [pClassName]);

  return <div className={className}>{children || <DialogFooterFallback {...props} />}</div>;
};

DialogFooter.defaultProps = {
  className: 'justify-center'
};

export default DialogFooter;
